module.exports = __webpack_public_path__ + "static/media/Akemi_5021.6ab5dbd0.jpg";